export const IncomeSchemaNegociationStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  IN_APPROVAL: "IN_APPROVAL",
  FINALIZED: "FINAL",
  CONFIRMED: "CONFIRMED"
};

export const IncomeSchemaFeeApprovalStatus = {
  IN_NEGOTIATION: "IN_NEGOTIATION",
  IN_PROGRESS: "IN_PROGRESS",
  APPROVAL_1: "APPROVAL_1",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED"
};

export const NegotiationType = {
  DOCUMENT: "D",
  PARTNER: "P",
  PARTNER_GROUP: "G"
};
